import { ButtonBase } from '@mui/material'
import type { ReactNode } from 'react'
import { colorTokens } from '../../../shared/styles/theme'
import { RADIUS } from '../../../shared/styles/radii'

/**
 * design-book `tab-pill.md`: 実 button・28px・radius md・active = bg.muted、hover は inactive にだけ。
 * 1 組のために pill を自作しない（hover が active を上書きして選択中が薄くなる事故を避ける）。
 * 置く側が `role="tablist"` の箱を持つ。
 */
export const TabPill = ({
  selected,
  onClick,
  children,
}: {
  selected: boolean
  onClick: () => void
  children: ReactNode
}) => (
  <ButtonBase
    role="tab"
    aria-selected={selected}
    onClick={onClick}
    sx={{
      height: 28,
      px: 1.25,
      borderRadius: `${RADIUS.md}px`,
      fontSize: 13,
      fontWeight: 500,
      whiteSpace: 'nowrap',
      transition: 'background-color 120ms',
      color: selected ? colorTokens.fg.default : colorTokens.fg.muted,
      background: selected ? colorTokens.bg.muted : 'transparent',
      '&:hover': {
        background: selected ? colorTokens.bg.muted : colorTokens.bg.emphasis,
      },
      '&:focus-visible': { boxShadow: colorTokens.focus.ringNeutral },
    }}
  >
    {children}
  </ButtonBase>
)
